module.exports = __webpack_public_path__ + "fa81cd045f0af308596ecd6f7ac20a52.jpg";